export class ApiResponse<ResponseType, ResponseCodeType> {
	response?: ResponseType;
	responseCode?: ResponseCodeType;
	messages?: Array<string>;
	errors?: Array<string>;
	hasErrors?: boolean;
}
